var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate90DegreesCw = function SvgRotate90DegreesCw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.606 21.952a8.3 8.3 0 0 1-3.316-.67 8.6 8.6 0 0 1-2.696-1.819 8.6 8.6 0 0 1-1.819-2.695 8.25 8.25 0 0 1-.67-3.316q0-3.54 2.48-6.02t6.02-2.48h.728L9.552 3.17l1.054-1.123 3.653 3.654-3.653 3.653-1.054-1.123 1.78-1.78h-.726q-2.925 0-4.963 2.037-2.037 2.038-2.037 4.963t2.037 4.962 4.963 2.038q.875 0 1.725-.213a6.8 6.8 0 0 0 1.625-.637l1.084 1.084a8.3 8.3 0 0 1-2.128.944 8.4 8.4 0 0 1-2.306.322m6-3.212-5.289-5.288 5.289-5.289 5.288 5.289zm0-2.138 3.15-3.15-3.15-3.15-3.15 3.15z"
  })));
};
export default SvgRotate90DegreesCw;